var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-minus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0371 16.9766H11.7871",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5 12.832V19.832C27.5 24.4987 26.25 25.6654 21.25 25.6654H8.75C3.75 25.6654 2.5 24.4987 2.5 19.832V8.16536C2.5 3.4987 3.75 2.33203 8.75 2.33203H10.625C12.5 2.33203 12.9125 2.84536 13.625 3.73203L15.5 6.06536C15.975 6.6487 16.25 6.9987 17.5 6.9987H21.25C26.25 6.9987 27.5 8.16536 27.5 12.832Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/follow-up.4988f36da506c71d15bf4f8eecf5bf05.svg";
export { ForwardRef as ReactComponent };